import { defineHeroThemeContract, type HeroThemeTokens } from '../../../art/contract';

/**
 * The petal hero's THEME (ADR-0099 / ADR-0102 / ADR-0117) — a soft lilac + leaf-green + blossom-pink garden
 * palette pulled from her painted art, with a gentle dawn-garden sky (her own world). Choosing her recolours the
 * WHOLE kid shell: the brand ramp drives buttons / meters / rings in lilac, the canvas blooms to a green+pink
 * garden dawn, and the hero stage takes her soft morning sky. Every brand colour is paired with its own
 * foreground for legibility.
 */
export const petalTheme: HeroThemeTokens = defineHeroThemeContract({
  // BRAND RAMP — lilac. `soft`→`primary` is the button/meter gradient (white text); `deep` is on-light text
  // (≈ 7:1 on the light kid surfaces); `tint` is the softest fill; `glow-rgb` = #8E5CCA for coloured shadows.
  '--color-primary': '#8E5CCA',
  '--color-primary-fg': '#FFFFFF',
  '--color-primary-soft': '#AF7FDB',
  '--color-primary-deep': '#5E3C8E',
  '--color-primary-tint': '#EFE4F8',
  '--color-primary-glow-rgb': '142 92 202',
  '--color-secondary': '#8FD694',
  '--color-secondary-fg': '#1F4A26',
  '--color-accent': '#FFB3CF',
  '--color-accent-fg': '#5A2138',
  // CANVAS — a leaf-green bloom top-left, a soft blossom-pink bloom bottom-right (a fresh garden dawn behind content).
  '--canvas-a': '#E6F6E8',
  '--canvas-b': '#FDE7F0',
  // A soft dawn-garden sky — lilac fading through green mist to a warm blossom glow (white text stays AA over it).
  '--sky-top': '#4a3a6e',
  '--sky-mid': '#7d69a8',
  '--sky-low': '#bcd9b8',
  '--sky-glow': '#ffd6e6',
  '--sky-fg': '#ffffff',
});
